
export class DataMetrics {
nbDeleted: number | null;
nbFreedataValues: number | null;
nbFreedatas: number | null;
nbLines: number | null;
nbValues: number | null;
numRev: number | null;
}

